import React from 'react';
import {
    Col, FormGroup, Input, Label,
    Row
} from 'reactstrap';

import {LangController} from "../../../components/tabs/langController";
import {LB_URL_VIDEO} from "../../../components/i18n/i18n";
import {FL_LONG_DESCRIPTION, FL_SHORT_DESCRIPTION, FL_TITLE} from "../../../components/i18n/formLabels";
import {PH_LONG_DESCRIPTION, PH_SHORT_DESCRIPTION, PH_TITLE} from "../../../components/i18n/placeHolders";
import MarkdownInput from "../../../components/inputs/MarkdownInput";

const PlaceLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name, showOrder: lang?.showOrder },
            title: '',
            image            : '',
            longDescription  : '',
            shortDescription2 : '',
            twoLetterCode    : '',
            videoUrl    : ''
        }) )
        setLangChilds(items);
    }

    const formHotel = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md="8">
                <FormGroup>
                    <MarkdownInput
                        label={FL_TITLE}
                        placeholder={PH_TITLE}
                        type="text"
                        name="title"
                        onChange={onInputChange}
                        disabled={disableInputs}
                        child={child}
                    />
                </FormGroup>
            </Col>
            <Col md="4">
                <FormGroup>
                    <Label>Imagen</Label>
                    <Input
                        type="text"
                        name="image"
                        placeholder="Imagen"
                        value={ child.image }
                        onChange={ ({target:{name, value}}) => onInputChange(name,value,child?.lang) }
                        disabled={ disableInputs }
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label>{LB_URL_VIDEO}</Label>
                    <Input
                        type="text"
                        name="videoUrl"
                        placeholder={LB_URL_VIDEO}
                        value= { child.videoUrl }
                        onChange={ ({target:{name, value}}) => onInputChange(name,value,child?.lang) }
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <MarkdownInput
                        label={FL_SHORT_DESCRIPTION}
                        placeholder={PH_SHORT_DESCRIPTION}
                        type="textarea"
                        name="shortDescription2"
                        rows={'5'}
                        onChange={onInputChange}
                        disabled={disableInputs}
                        child={child}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <MarkdownInput
                        label={FL_LONG_DESCRIPTION}
                        placeholder={PH_LONG_DESCRIPTION}
                        type="textarea"
                        name="longDescription"
                        rows={'10'}
                        onChange={onInputChange}
                        disabled={disableInputs}
                        child={child}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    const formEvents = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md="8">
                <FormGroup>
                    <Label>Título</Label>
                    <Input
                        type="text"
                        name="title"
                        placeholder="Título"
                        value={ child.title }
                        onChange={ ({target:{name, value}}) => onInputChange(name,value,child?.lang) }
                        disabled={ disableInputs }
                    />
                </FormGroup>
            </Col>
            <Col md="4">
                <FormGroup>
                    <Label>Código</Label>
                    <Input
                        type="text"
                        name="twoLetterCode"
                        placeholder="Codigo 2 o 3 letras"
                        value= { child.twoLetterCode }
                        onChange={ ({target:{name, value}}) => onInputChange(name,value,child?.lang) }
                        maxLength={10}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    const getFormulary = (child, index, disableInputs, onInputChange) => {
        switch (props.appCode) {
            case "EVENTS" :
                return formEvents(child, index, disableInputs, onInputChange)
            default:
                return formHotel(child, index, disableInputs, onInputChange)
        }
    }

    return <LangController
        markdown={true}
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />
}

export default PlaceLangs
